import React, { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { ArrowLeft, SkipForward, Flag, Heart } from 'lucide-react';
import { redFlagGreenFlagScenarios } from '../../data/mockData';

export default function RedFlagGreenFlag({ onBack }) {
  const { t } = useLanguage();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [redVotes, setRedVotes] = useState(0);
  const [greenVotes, setGreenVotes] = useState(0);
  const [hasVoted, setHasVoted] = useState(false);

  const scenario = redFlagGreenFlagScenarios[currentIndex % redFlagGreenFlagScenarios.length];

  const handleVote = (type) => {
    if (hasVoted) return;
    if (type === 'red') setRedVotes(prev => prev + 1);
    else setGreenVotes(prev => prev + 1);
    setHasVoted(true);
  };

  const nextScenario = () => {
    setCurrentIndex(prev => prev + 1);
    setRedVotes(0);
    setGreenVotes(0);
    setHasVoted(false);
  };

  const total = redVotes + greenVotes;

  return (
    <div data-testid="rfgf-game" className="p-4">
      <button data-testid="game-back-btn" onClick={onBack}
        className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors mb-4 text-sm">
        <ArrowLeft className="w-4 h-4" /> Back to games
      </button>
      <div className="text-center mb-6">
        <div className="text-4xl mb-2">{'\u{1F6A9}\u{1F49A}'}</div>
        <h3 className="font-display text-xl font-bold">{t('redFlagGreenFlag')}</h3>
        <p className="text-xs text-slate-400 mt-1">Scenario {currentIndex + 1}</p>
      </div>
      <div className="glass-card rounded-2xl p-6 text-center mb-6">
        <p className="text-lg font-medium leading-relaxed">{scenario}</p>
      </div>
      {/* Vote buttons */}
      <div className="flex gap-4 mb-4">
        <button data-testid="red-flag-btn" onClick={() => handleVote('red')}
          className={`flex-1 py-4 rounded-2xl flex flex-col items-center gap-2 transition-all ${hasVoted ? 'opacity-60' : 'hover:bg-red-500/20'} bg-red-500/10 text-red-400`}>
          <Flag className="w-6 h-6" />
          <span className="text-sm font-semibold">{t('redFlag')}</span>
          {hasVoted && <span className="text-xs">{total > 0 ? Math.round(redVotes / total * 100) : 0}%</span>}
        </button>
        <button data-testid="green-flag-btn" onClick={() => handleVote('green')}
          className={`flex-1 py-4 rounded-2xl flex flex-col items-center gap-2 transition-all ${hasVoted ? 'opacity-60' : 'hover:bg-emerald-500/20'} bg-emerald-500/10 text-emerald-400`}>
          <Heart className="w-6 h-6" />
          <span className="text-sm font-semibold">{t('greenFlag')}</span>
          {hasVoted && <span className="text-xs">{total > 0 ? Math.round(greenVotes / total * 100) : 0}%</span>}
        </button>
      </div>
      {/* Result bar */}
      {hasVoted && total > 0 && (
        <div className="h-3 rounded-full overflow-hidden flex mb-4">
          <div className="bg-red-500 transition-all" style={{ width: `${redVotes / total * 100}%` }} />
          <div className="bg-emerald-500 transition-all" style={{ width: `${greenVotes / total * 100}%` }} />
        </div>
      )}
      <div className="flex justify-center gap-3">
        <button data-testid="skip-rfgf-btn" onClick={nextScenario}
          className="px-6 py-2 rounded-full bg-white/5 hover:bg-white/10 text-sm flex items-center gap-2 transition-all">
          <SkipForward className="w-4 h-4" /> {t('skip')}
        </button>
        <button data-testid="next-rfgf-btn" onClick={nextScenario}
          className="px-6 py-2 rounded-full gradient-button text-sm">
          {t('next')}
        </button>
      </div>
    </div>
  );
}
